import { useQuery } from '@tanstack/react-query';

import { addOnsRepo, type AddOnsRequest } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useAddOns = (addOnsRequest: AddOnsRequest | null) => {
  const query = useQuery({
    queryKey: [QueryKeys.ADD_ONS, addOnsRequest],
    queryFn: () => {
      if (!addOnsRequest) {
        throw new Error('AddOnsRequest is required');
      }

      return addOnsRepo.getAddOns(addOnsRequest);
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: Boolean(addOnsRequest),
  });

  return useQueryMemoized(query);
};

export type UseAddOns = ReturnType<typeof useAddOns>;
